/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserTeam } from './userTeam';
import { Organization } from './organization';
import { Practice } from './practice';


import {ValidatorFn, Validators} from "@angular/forms";

export interface UserPatientOpsProfile { 
    readonly id: number;
    readonly organization: Organization;
    readonly practices: Array<Practice>;
    readonly teams: Array<UserTeam>;
}
export const UserPatientOpsProfile_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPatientOpsProfile_organization_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPatientOpsProfile_practices_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserPatientOpsProfile_teams_Validators: ValidatorFn[] =
    [  Validators.required, ];


